import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'

export default function RevereGod() {
  return (
    <PageLayout>
      <div className="book-page">
        <h1>Revere God and Fear Him.</h1>
        <blockquote>“And by the fear of the Lord one keeps away from evil.” (Proverbs 16:6b)</blockquote>

        <p>The first step in overcoming temptation is to keep in perspective who the Almighty God is. He is our Creator and the Judge of all we do and speak (2 Corinthians 5:10, Matthew 12:3). We fondly think of God as a loving, forgiving Father, and He is, but how much do we ponder the fact that our loving Father will discipline us to make us holy, who hates sin and has indignation every day (Psalm 7:11), and who is so terrifying that those who see God tremble with fear (Isaiah 6:5, Revelation 1:17)?</p>

        <p>God will judge all sin; He will suffer no fools. He is opposed to the proud, and views them as an abomination (Proverbs 16:5). As Christians, we will not get away with sin, for He will discipline us, and all unbelievers will spend eternity in the lake of fire because of sin (Hebrews 12:5-11, Revelation 21:8). As Christians, we ought to be more concerned about sin, not less. But because God is patient, and because so many around us are “doing it,” we think we can go along in our sin and it’s “okay,” or we fool ourselves into thinking that just because God does not punish or correct us immediately that He doesn’t mind or that He doesn’t really think it’s all that bad — but we are only deceiving ourselves.</p>

        <p>With a healthy fear of the Lord we will be aware of our sin, grieve over it, and be on guard against it. The first step in overcoming temptation, then, is to see God in His awesome holiness, through eyes of faith, and live our lives from an eternal viewpoint, knowing that “our God is a consuming fire” (Hebrews 12:29).</p>
        <ul>
          <li><strong>Fear God that you may not sin.</strong><br />
            Exodus 20:20, Deuteronomy 10:12, Job 1:8, 2:3, Psalm 4:4-5, 33:18, 34:7-9, 130:3-4, Proverbs 8:13, 14:27, 16:6, 19:23, Jeremiah 32:39-40, Hebrews 4:1, 1 Peter 1:17-19
          </li>
          <li><strong>Do not provoke God to anger or put Him to the test with your sin.</strong><br />
            Deuteronomy 28:58-59, Psalm 7:12, 76:7, 78:17-33, 90:7-11, 99:8, Matthew 4:7, Acts 5:9
          </li>
          <li><strong>Humble yourself before God and tremble at His Word.</strong><br />
            Proverbs 3:7-8, 11:2, 14:16, 16:18, 18:12, 29:23, Isaiah 66:2, Daniel 4:37,<br />
              Philippians 2:12-13, James 4:6,10, 1 Peter 5:6
            </li>
            <li><strong>Recognize pride and how it makes you stumble. God is opposed to the proud.</strong><br />
              Proverbs 3:7-8, 15:33, 16:5, 18, 22:4, 1 Peter 5:5-7
            </li>
            <li><strong>Recognize that God sees and will judge all thoughts, words, and deeds.</strong><br />
              Psalm 90:8, Ecclesiastes 12:13-14, Jeremiah 17:10, Mark 4:22, Romans 2:16, 2 Corinthians 5:10, Hebrews 4:12-13,1 Peter 4:5
            </li>
            <li><strong>Know that God will discipline you to make you holy.</strong><br />
              Psalm 39:11, Proverbs 16:5, Galatians 6:7-8, Hebrews 2:2, 12:5-11, Revelation 3:19
            </li>
            <li><strong>Submit to God and to those in authority over you.</strong><br />
              Romans 13:1-7, Colossians 3:18-4:1, James 4:7, 1 Peter 2:13-3:7, 5:5
            </li>
            <li><strong>Fear the Lord that you may gain wisdom.</strong><br />
              Proverbs 1:7
            </li>
            <li><strong>Do not fear or trust in man.</strong><br />
              1 Samuel 15:24, Proverbs 29:25, Isaiah 51:7-8, 12-13, Jeremiah 17:5-8, Matthew 10:28
            </li>
            <li><strong>Do not trust in yourself.</strong><br />
              Proverbs 3:5-6, 16:25, 28:26
            </li>
          </ul>

      </div>
    </PageLayout>
  );
};
